import { combineReducers } from 'redux'
import ui from './ui'
import session from './session'

const reducer = combineReducers({ ui, session })

export default reducer